const menuList = [
  {
    "name": "Users",
    "icon": "fa fa-users",
    "type": "menu",
    "translate": "用户管理",
    "parent": "",
    "routeName": "UserManagement"
  },
  {
    "name": "EAN",
    "icon": "fa fa-barcode",
    "type": "menu",
    "translate": "EAN管理",
    "parent": "",
    "routeName": "EANCode"
  },
  {
    "name": "QRC",
    "icon": "fa fa-qrcode",
    "type": "menu",
    "translate": "QRC管理",
    "parent": "",
    "routeName": "QRCCode"
  },
  {
    "name": "BoxScan",
    "icon": "fa fa-inbox",
    "type": "menu",
    "translate": "装箱扫描",
    "parent": "",
    "routeName": "BoxScan"
  },
  {
    "name": "Delivery",
    "icon": "fa fa-truck",
    "type": "menu",
    "translate": "发货管理",
    "parent": "",
    "routeName": "Delivery"
  },
  {
    "name": "ProductReturn",
    "icon": "fa fa-recycle",
    "type": "menu",
    "translate": "退货管理",
    "parent": "",
    "routeName": "ProductReturn"
  },
  {
    "name": "Cashback",
    "icon": "fa fa-gift",
    "type": "menu",
    "translate": "返现信息",
    "parent": "",
    "routeName": "Cashback"
  },
  {
    "name": "CMUser",
    "icon": "fa fa-user-o",
    "type": "menu",
    "translate": "客户信息",
    "parent": "",
    "routeName": "CMUser"
  },
  {
    "name": "CodeScanningInformation",
    "icon": "fa fa-comments",
    "type": "menu",
    "translate": "扫码信息",
    "parent": "",
    "routeName": "CodeScanningInformation"
  },
  {
    "name": "Report",
    "icon": "fa fa-bar-chart",
    "type": "menu",
    "translate": "报表管理",
    "parent": "",
    "routeName": "Report"
  },

]

export default menuList;


// WEBPACK FOOTER //
// ./src/Infrustructure/menu.js